import React from "react";
import Modal from "./Modal";

import "./Modal.css";

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary", // primary, danger, warning
  icon = null,
}) => {
  const variantColors = {
    primary: { bg: "var(--primary)", hover: "var(--primary-dark)" },
    danger: { bg: "#dc3545", hover: "#c82333" },
    warning: { bg: "#f57c00", hover: "#e65100" },
  };

  const color = variantColors[variant] || variantColors.primary;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false}>
      <div className="confirm-modal-content">
        {icon && <div className="confirm-modal-icon">{icon}</div>}
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            {cancelText}
          </button>
          <button
            className="btn-primary"
            onClick={onConfirm}
            style={{
              background: color.bg,
              "--hover-bg": color.hover,
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
